<template>
    <div id="login" class="auth-form mx-auto my-auto col-md-7 col-sm-7 col-xs-12 col-lg-3">
        <div class="card">
            <div class="card-body">
                <img src="../../assets/images/logo.jpg" alt="Székelyföld.ma" class="w-100 auth-form__logo d-table mx-auto mb-3">
                <h5 class="auth-form__title text-center mb-4">Belépés a rendszerbe</h5>

                    <div class="form-group">
                        <label for="exampleInputEmail1">E-mail</label>
                        <input id="exampleInputEmail1"
                               type="email" placeholder="Enter email" class="form-control"
                               @keypress="loginEnter"
                               v-model="loginData.email">
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">Jelszó</label>
                        <input id="exampleInputPassword1" type="password"
                               placeholder="Password" class="form-control"
                               @keypress="loginEnter"
                               v-model="loginData.password">
                    </div>
                    <div class="form-group mb-3 d-none mx-auto">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" autocomplete="off" class="custom-control-input" value="1" v-model="loginData.remember">
                            <label class="custom-control-label"></label>
                            <span class="custom-control-description">Remember me for 30 days.</span>
                        </label>
                    </div>
                    <button type="button" class="btn btn-pill btn-accent d-table mx-auto" @click="login">Bejelentkezés</button>

            </div>
            <div class="border-top card-footer">
                <ul class="auth-form__social-icons d-table mx-auto">

                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters, mapActions } from 'vuex'

    export default{
        name: 'Login',
        data(){
            return {
                loginData: {
                    email: '',
                    password: '',
                    remember: false
                }
            }
        },
        computed:{
            ...mapGetters([
                'appSettings',
                'getAppSettingsByCode',
                'user',
                'isLogoutProgress'
            ]),
            isLoggingOut: {
                get: function() {
                    return this.isLogoutProgress;
                },
                set: function(newVal) {
                    return newVal;
                }
            }
        },
        methods: {
            ...mapActions([

            ]),
            async login(){
                await this.$store.dispatch('login', this.loginData).then((response) => {

                    if(response.data){
                        let redirectData = this.appSettings.find(s => s.name == this.$appSettingCodes.REDIRECT_AFTER_LOGIN);
                        let redirectURL = '/';

                        let fwd = this.$route.query.fwd;
                        if(fwd){
                          redirectURL = fwd;
                        }else{
                            if(redirectData && redirectData.value){
                                redirectURL = redirectData.value;
                            }
                        }

                        if(this.$route && this.$route.name === 'home') {
                            this.$router.push({
                                path: redirectURL,
                            });
                        }

                    }else{
                        this.$messaging.DisplayError('Hiba', 'Hibás e-mail cím vagy jelszó!');
                    }
                }).catch((err) => {
                  this.$messaging.DisplayError('Hiba', 'Hibás e-mail cím vagy jelszó!');
                    console.log('Login error', err);
                });
            },
            loginEnter(e) {
                if (e.keyCode == 13) {
                    this.login();
                }
            },
            handleMessages: function(){
                if((this.user === null || !this.user.ID ) && (this.$route && this.$route.name !== 'home')){
                    if(!this.isLoggingOut) {
                        this.$messaging.DisplayError('', 'Jelentkezzen be a folytatáshoz!');
                    }
                }
            }
        },
        mounted(){
            this.handleMessages();
        },
        watch: {
            isLogoutProgress: function(newVal) {
                this.isLoggingOut = newVal;
            },
            isLoggingOut: function(newVal) {
            }
        }
    }
</script>

<style scoped>
    .card-body {
        overflow: hidden;
    }
</style>
